<div class="dialog-content-wrapper">
    <mat-toolbar class="mat-primary m-0">
        <mat-toolbar-row
            fxFlex
            fxLayout="row"
            fxLayoutAlign="space-between center"
        >
            <span class="title dialog-title text-truncate"
                >Informar pago a contratista</span
            >
            <button
                style="float: right"
                mat-icon-button
                (click)="dialogRef.close()"
                aria-label="Close dialog"
            >
                <mat-icon>close</mat-icon>
            </button>
        </mat-toolbar-row>
    </mat-toolbar>
    <mat-dialog-content class="p-16 pb-0 m-0">
        <form class="form mt-8" [formGroup]="formPago" autocomplete="off">
            <mat-form-field class="full-width mt-8">
                <mat-label>Monto</mat-label>
                <input
                    matInput
                    type="number"
                    formControlName="monto"
                    required
                />
                <span matPrefix>$&nbsp;</span>
                <mat-error *ngIf="monto.hasError('required')">
                    Debe ingresar el monto a pagar
                </mat-error>
                <mat-error *ngIf="monto.hasError('min')">
                    Debe ingresar un monto válido
                </mat-error>
            </mat-form-field>
        </form>
    </mat-dialog-content>

    <mat-divider></mat-divider>
    <mat-dialog-actions
        class="m-0 p-16"
        fxLayout="row"
        fxLayoutAlign="end center"
    >
        <button mat-button mat-dialog-close>Cancelar</button>

        <button
            mat-raised-button
            color="accent"
            [mat-dialog-close]="monto.value"
            [disabled]="!formPago.valid"
        >
            Pagar
        </button>
    </mat-dialog-actions>
</div>
